import {EntityModel} from "@fedeltapointofsale/data-client";
import {MarketingCampaignData} from "./marketing-campaign.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class MarketingCampaignEntityModel extends EntityModel<MarketingCampaignData> {
    constructor(injector: Injector) {
        super(injector, MarketingCampaignData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
